import { z } from "zod";

import {
  ApiV1FilterTagsSchema,
  ApiV1TagSchema,
  ApiV1TagSchemaResponse,
} from "./shared";

export const ApiV1ListResponseSchema = <T extends z.AnyZodObject>(items: T) =>
  z.object({
    items: z.array(items),
    aggregations: z.any(),
    nextToken: z.string().nullable(),
    total: z.number(),
  });

export const ApiV1ItemScoringSchema = z.object({
  points: z.number().nullable(),
  questions: z.array(
    z.object({
      id: z.string(),
      interactionType: z.string(),
      points: z.number().nullable(),
      prompt: z.string().optional(),
    }),
  ),
});

export const ApiV1ItemSchema = z.object({
  id: z.string(),
  idInc: z.string().optional().nullable(),
  idVendor: z.string().optional().nullable(),
  createdAt: z.string().optional().nullable(),
  updatedAt: z.string().optional().nullable(),
  name: z.string().optional().nullable(),
  workspaceId: z.string().optional().nullable(),
  alignments: z.array(z.unknown()).optional().nullable(),
  tags: z.array(ApiV1TagSchemaResponse).optional().nullable(),
  scoring: ApiV1ItemScoringSchema.optional().nullable(),
  content: z
    .object({
      questions: z.array(
        z.object({
          id: z.string(),
          interactionType: z.string(),
        }),
      ),
    })
    .optional()
    .nullable(),
});

export const ApiV1GetItemsResponseSchema =
  ApiV1ListResponseSchema(ApiV1ItemSchema);

export const ApiV1GetItemsRequestSchema = z.object({
  nextToken: z.string().optional(),
  include: z.array(z.enum(["objectives", "content"])).optional(),
  objectiveAuthorityIds: z.array(z.string()).optional(),
  filter: z
    .object({
      itemIds: z
        .object({
          include: z.array(z.string()).optional(),
        })
        .optional(),
      tags: ApiV1FilterTagsSchema.optional(),
    })
    .optional(),
});

export const ApiV1CreateItemRequestContentSchema = z.object({
  questions: z.array(
    z.object({
      type: z.literal("choice"),
      prompt: z.object({ body: z.string() }),
      options: z.array(z.object({ text: z.string(), isKey: z.boolean() })),
    }),
  ),
});

export const ApiV1CreateItemRequestSchema = z.object({
  title: z.string(),
  content: ApiV1CreateItemRequestContentSchema.optional(),
  tags: z.array(ApiV1TagSchema).optional(),
});

export const ApiV1PutItemRequestSchema = z.object({
  title: z.string().optional(),
  content: ApiV1CreateItemRequestContentSchema.optional(),
  tags: z.array(ApiV1TagSchema).optional(),
});
